export default __webpack_public_path__ + "static/media/logo.a02159f2.png";